import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { InputModel } from '../../models';
import { InputWithoutSource } from '../../componentTypes';
import { GenericPercentageInput } from '../../components';


const AmountPercentInput: InputWithoutSource = ({ input }) => (
    <GenericPercentageInput label={input.name} input={input} />
);

AmountPercentInput.meta = {
    inputType: InputModel.name
};

export default observer(AmountPercentInput);
